import { aawzDate } from '@utils/dates/aawz-date'
import { instanteDaDataDoBackend } from '@modules/aawz-intelligence-v2/utils/data-do-backend'

// Formata a data de uma conversa em rótulo relativo curto (agora / há N min /
// há Nh / ontem / há N dias / DD/MM). Extraído para ser reusado pela linha de
// conversa (loose e dentro de pasta) sem duplicar a lógica.
export function formatConversationDate(dateStr) {
  if (!dateStr) return ''
  // ⚠️ Nunca `parseDateSafe` aqui: o round-trip dele lê "12/09/2026 22:49"
  // como 9 de DEZEMBRO (data em UTC × hora local no `format()` do aawzDate) —
  // toda conversa das 21h em diante virava "agora" (print do usuário,
  // 14/09/2026). `data-do-backend.js` decide o formato pela forma da string.
  const instante = instanteDaDataDoBackend(dateStr)
  if (instante === null) return ''
  const diffMs = aawzDate().valueOf() - instante
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return 'agora'
  if (diffMins < 60) return 'há ' + diffMins + ' min'
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return 'há ' + diffHours + 'h'
  const diffDays = Math.floor(diffMs / 86400000)
  if (diffDays === 1) return 'ontem'
  if (diffDays < 7) return 'há ' + diffDays + ' dias'
  // ⚠️ `DD/MM` por getters LOCAIS, nunca `aawzDate(...).format('DD/MM')`: o
  // `format()` do `aawzDate` lê o dia em UTC (`getUTCDate`), e conversa das
  // 21h em diante ganhava o dia seguinte (review #2261 r3). Dívida do
  // `aawz-date/format.js` registrada em `design-system/guidelines.md`.
  return diaMesLocal(new Date(instante))
}

// `DD/MM` por getters LOCAIS (ver o aviso acima de `formatConversationDate`).
function diaMesLocal(data) {
  const dois = (n) => String(n).padStart(2, '0')
  return dois(data.getDate()) + '/' + dois(data.getMonth() + 1)
}
